import { matchPath } from 'react-router-dom';
import { flow, get, map, head, filter } from 'lodash/fp';
import routes from './routes';

export default (url) =>
  flow(
    map((route) => ({ route, match: matchPath(url, route) })),
    filter(get(['match'])),
    head,
  )(routes);
